import { SVGProps, Ref, forwardRef } from 'react';

export const ShareWebOutlinedSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <g>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="m11.794 9.633-1.38.322c-5.1 1.191-7.233 4.52-8.134 7.277 1.966-1.106 4.63-2.244 7.586-2.485l1.914-.156.032 1.92c.018 1.107.066 1.846.16 2.358q.021.115.043.202c.483-.215 1.166-.629 2.278-1.316l3.405-2.105c1.843-1.139 3.023-1.875 3.774-2.536.684-.602.728-.895.728-1.114s-.044-.512-.728-1.114c-.751-.66-1.931-1.397-3.774-2.536l-3.405-2.105c-1.112-.687-1.795-1.101-2.278-1.316a4 4 0 0 0-.07.366c-.098.644-.132 1.56-.141 2.92zm-3.577 7.18a14 14 0 0 1 1.795-.272c.012.69.034 1.286.08 1.8.1 1.143.31 1.872.75 2.309.843.833 2.028.1 4.397-1.364l3.406-2.105C22.215 14.974 24 13.871 24 12s-1.785-2.974-5.355-5.181l-3.406-2.105c-2.37-1.465-3.554-2.197-4.396-1.364-.707.7-.821 2.153-.84 4.852C2.517 9.952.535 15.78.014 18.97c-.137.838.82 1.316 1.523.84 1.516-1.029 3.914-2.392 6.68-2.998"
                    fill="currentColor"
                />
            </g>
        </g>
    </svg>
));
ShareWebOutlinedSize24Glyph.displayName = 'ShareWebOutlinedSize24Glyph';
